module.exports = __webpack_public_path__ + "img/img1.502ddd04.jpg";